export const experience = [
  {
    position: "Senior Software Engineer",
    company: "Y Tree",
    companyLink: "https://www.y-tree.com/",
    location: "London, UK (Hybrid)",
    dates: {
      real: { startDate: "2024-08", endDate: "2026-06" }, // 27-08-2024 – 08-06-2026
      linkedin: { startDate: "2024-08", endDate: "2026-06" },
      nooverlap: { startDate: "2024-08", endDate: "2026-06" },
    },
    companyLogo: "YTreeLogo",
    skills: [
      "React",
      "TypeScript",
      "Playwright",
      "i18next",
      "Anthropic Claude",
      "LLM/MCP/RAG",
      "Agentic Workflows",
    ],
    bullets: [
      '**Led frontend development** of the "Wealth Overview" — an interactive portfolio dashboard featuring value tracking, performance metrics, exposure breakdowns and historical trends with configurable timeframes; increasing **user engagement by 30%** and reducing data-clarity requests to the advice team.',
      "Designed and delivered complex digital onboarding journeys covering automated identity verification, personal, financial and tax questionnaires, and dynamic T&Cs based on service tier; helping reduce onboarding time from **30+ days to under 7 days** and significantly lowering operational workload.",
      "Developed a customer-facing document management portal enabling clients to navigate, view and download financial documents, advice reports and fee schedules — replacing manual email exchanges with a centralised experience integrated with back-office systems.",
    ],
  },
  {
    position: "Engineering Lead",
    company: "Apiari",
    companyLink: "https://www.linkedin.com/company/theapiari/",
    location: "London, UK (Remote)",
    dates: {
      real: { startDate: "2023-02", endDate: "2026-05" }, // 01-05-2026
      linkedin: { startDate: "2023-02", endDate: "2025-01" },
      nooverlap: { startDate: "2023-02", endDate: "2024-08" },
    },
    companyLogo: "ApiariLogo",
    skills: [
      "React",
      "Next.js",
      "TypeScript",
      "GraphQL",
      "Node.js",
      "AWS",
      "DynamoDB",
    ],
    bullets: [
      "Led development of customer-facing applications and care-provider workflows using React, Next.js and TypeScript, supporting childcare discovery, matching, booking and communication across a nationwide marketplace.",
      "Designed and built a location-based matching experience using the Google Maps API, enabling users to discover suitable childcare providers and supporting the product’s expansion from a **New York City-only solution to a nationwide platform**.",
      "Created and implemented a technical strategy to incrementally modernise the legacy frontend stack, improving maintainability, development speed and the team’s ability to deliver new customer-facing features.",
      "Led integrations with Stripe, Twilio, Google Maps, Slack and Checkr, delivering frontend and operational workflows for payments, communication, geolocation, background verification and internal platform automation.",
    ],
  },
  {
    position: "Senior Full-stack Engineer",
    company: "Ciklum",
    companyLink: "https://www.linkedin.com/company/ciklum/",
    location: "Lviv, Ukraine (Remote)",
    // from the 22d of March 2021 until the 8th of November 2023 in the capacity of Senior JavaScript Developer;
    // from the 9th of November 2023 until present time in the capacity of Senior JavaScript Software Engineer.
    dates: {
      real: { startDate: "2021-03", endDate: "2024-07" }, // 22-03-2021 -> 09-11-2023 -> 17-07-2026
      linkedin: { startDate: "2021-03", endDate: "2024-07" }, // 22-03-2021 -> 09-11-2023 -> 17-07-2026
      nooverlap: { startDate: "2021-03", endDate: "2023-02" },
    },
    companyLogo: "CiklumLogo",
    skills: [
      "React",
      "TypeScript",
      "GraphQL",
      "Node.js",
      "PostgreSQL",
      "Kafka",
      "Nest.js",
    ],
    bullets: [
      "Designed and delivered a configuration-driven application for creating, reviewing, processing and submitting AML disclosures across major economic regions, simplifying complex compliance workflows for enterprise users.",
      "Developed React-facing APIs and supporting microservices for authentication, permissions and disclosures within the SymphonyAI FinTech platform using TypeScript, Node.js, PostgreSQL, Kafka and Nest.js.",
    ],
  },
  {
    position: "Full Stack Engineer",
    company: "Lohika",
    companyLink: "https://www.linkedin.com/company/lohika/",
    location: "Lviv, Ukraine (Hybrid)",
    dates: {
      real: { startDate: "2019-02", endDate: "2021-03" },
      linkedin: { startDate: "2019-02", endDate: "2021-03" },
      nooverlap: { startDate: "2019-02", endDate: "2021-03" },
    },
    companyLogo: "LohikaLogo",
    skills: ["React", "TypeScript", "Redux", "Formik", "Ant Design", "Git"],
    bullets: [
      "Built a React and TypeScript fleet and airport management system for Air Arabia, delivering complex operational interfaces, data-driven workflows and reusable form components.",
      "Ensured strong performance across multi-level dynamic forms and components by optimising data calculations, application state and rendering behaviour throughout the frontend.",
    ],
  },
  {
    position: "Middle Full Stack Engineer",
    company: "ProductCrafters",
    companyLink: "https://www.linkedin.com/company/product-crafters/",
    location: "Khmelnytsky, Ukraine (On-site)",
    dates: {
      real: { startDate: "2017-12", endDate: "2019-02" },
      linkedin: { startDate: "2017-12", endDate: "2019-02" },
      nooverlap: { startDate: "2017-12", endDate: "2019-02" },
    },
    companyLogo: "ProductCraftersLogo",
    skills: [
      "JavaScript",
      "Node.js",
      "Redis",
      "PostgreSQL",
      "MongoDB",
    ],
    bullets: [
      // "Delivered full-stack functionality across multiple agency projects, with a strong focus on implementing customer-facing interfaces and integrating them with backend services and external APIs.",
      "Built comprehensive frontend experiences with an emphasis on responsive design, usability, accessibility and consistent user experience across different products and devices.",
    ],
  },
];

export const summary =
`
  Software engineer with 9+ years of experience. Skilled in developing pragmatic,
  well-tested, and maintainable solutions with a strong focus on user experience, code quality, and business value.
  Particularly interested in **FinTech**, Python, **Data Science, AI**, and **Machine Learning.**
`;
